export const PASSPORT_REMINDER = "Please check that every traveller's passport is valid for at least six months from the date of travel.";
export const PASSPORT_RENEW = "If any traveller's passport will have less than six months' validity remaining on the date of travel, they must renew it immediately before proceeding with the booking.";
export const PASSPORT_ACK_WORDING = "I confirm that I have checked all travellers' passports and that each passport is valid for at least six months from the date of travel.";

const BANDS = { INFANT: [0, 1], CHILD: [2, 11], YOUTH: [12, 17], ADULT: [12, 130] };
const LABEL = { INFANT: 'an infant (under 2)', CHILD: 'a child (2–11)', YOUTH: 'a youth (12–17)', ADULT: 'an adult (12+)' };

export const normaliseType = (t) => {
  const u = String(t || 'ADULT').toUpperCase();
  return { INFANT_WITHOUT_SEAT: 'INFANT', INFANT_WITH_SEAT: 'INFANT', CHD: 'CHILD', ADT: 'ADULT', INF: 'INFANT' }[u] || u;
};

export const ageOn = (dob, when) => {
  const d = new Date(dob); const w = new Date(when);
  let a = w.getFullYear() - d.getFullYear();
  if (w.getMonth() < d.getMonth() || (w.getMonth() === d.getMonth() && w.getDate() < d.getDate())) a -= 1;
  return a;
};

const nameOk = (v) => { const s = String(v || '').trim(); return s.length >= 2 && s.length <= 40 && /^[A-Za-z '\-]+$/.test(s) && /[A-Za-z]/.test(s); };

/** Returns an error string for one traveller, or null. `who` is the label (e.g. "Traveller 2"). */
export const travellerError = (p, who, departDate, returnDate) => {
  const type = normaliseType(p.type);
  if (!nameOk(p.first_name) || !nameOk(p.last_name)) return `${who}: enter the full name exactly as shown on the passport (letters only)`;
  if (!p.date_of_birth) return `${who}: date of birth is required`;
  const dob = new Date(p.date_of_birth);
  if (Number.isNaN(dob.getTime())) return `${who}: date of birth is not a valid date`;
  if (dob > new Date()) return `${who}: date of birth cannot be in the future`;
  const dep = departDate || new Date().toISOString().slice(0, 10);
  const a = ageOn(p.date_of_birth, dep);
  const [lo, hi] = BANDS[type] || BANDS.ADULT;
  if (a < lo || a > hi) return `${who}: aged ${a} on ${dep} — does not match ${LABEL[type] || LABEL.ADULT}`;
  if (type === 'INFANT' && returnDate && ageOn(p.date_of_birth, returnDate) > 1) return `${who}: turns 2 before the return date — must travel as a child`;
  if (p.passport_expiry && p.passport_expiry < sixMonthsAfter(dep)) return `${who}: passport expires ${p.passport_expiry} — less than six months' validity on the date of travel. ${PASSPORT_RENEW}`;
  return null;
};

export const sixMonthsAfter = (iso) => {
  const d = new Date(iso); const t = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 6, 1));
  const last = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0)).getUTCDate();
  t.setUTCDate(Math.min(d.getUTCDate(), last));
  return t.toISOString().slice(0, 10);
};

export const passportAcknowledgement = (accepted) => ({ passport_validity: { accepted: !!accepted, wording: PASSPORT_ACK_WORDING, accepted_at: accepted ? new Date().toISOString() : null } });
